import * as service from './service'
export default {
  namespace: 'shansongStudyStudyTask',
  state: {
    listData: []
  },
  effects: {
    * getList ({ payload }, { call, put }) {
      const res = yield call(service.getList, payload)
      yield put({
        type: 'save',
        payload: {
          listData: res.data.data
        }
      })
      return res.data
    },
    * getSiteList ({ payload }, { call, put }) {
      const res = yield call(service.getSiteList, payload)
      return res.data
    },
    * getTimeSlotList ({ payload }, { call, put }) {
      const res = yield call(service.getTimeSlotList, payload)
      return res.data
    },
    * booking ({ payload }, { call, put }) {
      const res = yield call(service.booking, payload)
      yield put({
        type: 'save',
        payload: {
          // listData: res.data.data
        }
      })
      return res.data
    },
    * taskDetail ({ payload }, { call, put }) {
      const res = yield call(service.taskDetail, payload)
      yield put({
        type: 'save',
        payload: {
          // listData: res.data.data
        }
      })
      return res.data
    },
    * waitTrain ({ payload }, { call, put }) {
      const res = yield call(service.waitTrain, payload)
      yield put({
        type: 'save',
        payload: {
          // listData: res.data.data
        }
      })
      return res.data
    },
    * resultBooking ({ payload }, { call, put }) {
      const res = yield call(service.resultBooking, payload)
      yield put({
        type: 'save',
        payload: {
          // listData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
